module.exports = __webpack_public_path__ + "static/media/YB5F15_3.cd963bae.jpg";